import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Outlet } from 'react-router-dom';
import { locations } from 'services/routes/locations';
import {
  HeaderContainer,
  LibraryTracksHeader,
  StyledNavLink,
  LibraryTracksContainer,
  LibraryTrackNavbar,
} from './styled';

const LibraryTracks = () => {
  const { t } = useTranslation();
  return (
    <LibraryTracksContainer>
      <HeaderContainer>
        <LibraryTracksHeader variant="h1">
          {t('library:tracks:heading')}
        </LibraryTracksHeader>
        <LibraryTrackNavbar>
          <StyledNavLink to={locations.library.tracks.liked.route}>
            {t('library:tracks:liked')}
          </StyledNavLink>
          <StyledNavLink to={locations.library.tracks.studio.route}>
            {t('library:tracks:studio')}
          </StyledNavLink>
        </LibraryTrackNavbar>
      </HeaderContainer>
      <Box
        sx={{
          flex: 1,
          overflow: 'hidden',
        }}
      >
        <Outlet />
      </Box>
    </LibraryTracksContainer>
  );
};

export default LibraryTracks;
